<div class="ontario-alert ontario-alert--success" [class.table]="buttonText && !successMessage">
    <div class="ontario-alert__header" [class.table-cell]="buttonText && !successMessage">
      <div class="ontario-alert__header-icon">
        <svg class="ontario-icon" [attr.aria-label]="successTitle" aria-hidden="true" focusable="false" sol:category="primary" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
          <use xlink:href="#ontario-icon-alert-success"></use>
        </svg>
      </div>
      <h2 class="ontario-alert__header-title ontario-h4">{{successTitle}}</h2>
    </div>
  </div>